var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"2"}},[_c('input_decimal',{attrs:{"label":"","prefix":"%","amount":_vm.wizardData.margin_quantity,"field":"margin_quantity"},on:{"updateData":_vm.updateData}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }